import React from 'react';
import ParcelForm from '../components/ParcelForm';
import DistanceCalc from '../components/DistanceCalc';
import SearchBox from '../components/SearchBox';
import Services from '../components/Services';
import Partners from '../components/Partners';
import Subscribe from '../components/Subscribe';
import CourierList from './CourierList';
import CargoCompanies from './CargoCompanies';


const Home = () => {
  return (
    <>
      <SearchBox /> 
      <CourierList />
      <CargoCompanies />      
      <Services />
      <Partners />
      <Subscribe />
    </>
  );
};

export default Home;
